import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Slideshow from "./components/Slideshow";
import About from "./components/About";
import { Box } from "@mui/material";
import ServicesSection from "./components/ServicesSection";
import Principles from "./components/Principles";
import Industries from "./components/Industries";
import HomeContact from "./components/HomeContact";
import Footer from "./components/Footer";
import ContactTab from "./components/ContactTab";
import WhatsAppFloat from "./components/WhatsAppFloat";
import ServiceHome from "./components/ServiceHome";
import Bigdata from "./components/Bigdata";
import Itstaffing from "./components/Itstaffing";
import Websites from "./components/Websites";
import OperationalAnalytics from "./components/OperationalAnalytics";
import AboutTab from "./components/AboutTab";
import IndustriesHome from "./components/IndustriesHome";
import Health from "./components/Health";
import Automobile from "./components/Automobile";
import Banking from "./components/Banking";
import Automotivecs1 from "./components/Automotivecs1";
import Automotivecs2 from "./components/Automotivecs2";
import Healthcs1 from "./components/Healthcs1";
import Healthcs2 from "./components/Healthcs2";
import Bankingcs1 from "./components/Bankingcs1";
import Bankingcs2 from "./components/Bankingcs2";
import Education from "./components/Education";
import Educationcs1 from "./components/Educationcs1";
import Educationcs2 from "./components/Edducationcs2";
import Retail from "./components/Retail";
import Retailcs1 from "./components/Retailcs1";
import Retailcs2 from "./components/Retailcs2";
import Manufacturing from "./components/Manufacturing";
import Manufacturingcs1 from "./components/Manufacturingcs1";
import Careers from "./components/Careers";
import JobDetailPage1 from "./components/JobDetailPage1";
import JobDetailPage2 from "./components/JobDetailPage2";
import Careercs1 from "./components/Careercs1";
import Careercs2 from "./components/Careercs2";


function App() {
  return (
    <Router>
      <Box sx={{ paddingTop: "80px" }}>
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Slideshow />
                <About />
                <ServicesSection />
                <Principles />
                <Industries />
                <HomeContact />
                <Footer />
              </>
            }
          />
          <Route path="/contact" element={<ContactTab />} />
          <Route path="/servicehome" element={<ServiceHome />} /> 
          <Route path="/bigdata" element={<Bigdata />} /> 
          <Route path="/itstaffing" element={<Itstaffing/>} /> 
          <Route path="/websites" element={<Websites/>} /> 
          <Route path="/opeana" element={<OperationalAnalytics/>} /> 
          <Route path="/careers" element={<Careers/>} /> 
          <Route path="/about" element={<AboutTab/>} /> 
          <Route path="/industrieshome" element={<IndustriesHome/>} /> 
          <Route path="/health" element={<Health/>} /> 
          <Route path="/automobile" element={<Automobile/>} /> 
          <Route path="/banking" element={<Banking/>} /> 
          <Route path="/automotivecs1" element={<Automotivecs1/>} /> 
          <Route path="/automotivecs2" element={<Automotivecs2/>} /> 
          <Route path="/healthcs1" element={<Healthcs1/>} /> 
          <Route path="/healthcs2" element={<Healthcs2/>} /> 
          <Route path="/bankingcs1" element={<Bankingcs1/>} /> 
          <Route path="/bankingcs2" element={<Bankingcs2/>} /> 
          <Route path="/education" element={<Education/>} /> 
          <Route path="/educationcs1" element={<Educationcs1/>} /> 
          <Route path="/educationcs2" element={<Educationcs2/>} /> 
          <Route path="/retail" element={<Retail/>} /> 
          <Route path="/retailcs1" element={<Retailcs1/>} />   
          <Route path="/retailcs2" element={<Retailcs2/>} /> 
          <Route path="/manufacturing" element={<Manufacturing/>} /> 
          <Route path="/manufacturingcs1" element={<Manufacturingcs1/>} />   
          <Route path="/job/ui-developer" element={<JobDetailPage1 />} />
          <Route path="/job/sales-marketing" element={<JobDetailPage2 />} />
          <Route path="/careercs1" element={<Careercs1/>} /> 
          <Route path="/careercs2" element={<Careercs2/>} /> 


          
        </Routes>
        <WhatsAppFloat />
      </Box>
    </Router>
  );
}

export default App;
